export default __webpack_public_path__ + "static/media/cy.d41b6b64.svg";